import React, { useState } from "react";
import ColorPicker from "./ColorPicker.react";

/**
 * GradientPicker allows selection of two colors and applies a linear gradient
 * background to the design canvas.
 * Props:
 *  - onCancel: function to call when cancelling gradient selection
 */
const GradientPicker = ({ onCancel }) => {
  const [startColor, setStartColor] = useState("#ffffff");
  const [endColor, setEndColor] = useState("#000000");

  const applyGradient = () => {
    const baseObject = window.editor.getBaseObject();
    if (!baseObject) {
      onCancel();
      return;
    }
    const width = baseObject._width;
    const height = baseObject._height;
    // create an HTML canvas to draw gradient
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    // vertical gradient top to bottom
    const grad = ctx.createLinearGradient(0, 0, 0, height);
    grad.addColorStop(0, startColor);
    grad.addColorStop(1, endColor);
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, width, height);
    // upload and apply gradient as an asset, then save to cloud/project
    const dataUrl = canvas.toDataURL("image/png");
    // load via editor pipeline (handles upload and asset registration)
    window.editor.loadTextureFromUrl(dataUrl, (texture) => {
      // remove any existing design background
      if (window.editor.deleteDesignBackground) window.editor.deleteDesignBackground();
      // apply new gradient texture
      window.editor.addDesignBackground(texture, texture.id, () => {
        // trigger save
        window.editor.autoSave();
      });
    });
    // close picker
    onCancel();
  };

  return (
    <div className="gradient-picker" style={{ padding: '8px' }}>
      <div
        style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '8px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ColorPicker
          text="Start Color"
          onColor={setStartColor}
          initialColor={startColor}
          opacity={1}
        />
        <ColorPicker
          text="End Color"
          onColor={setEndColor}
          initialColor={endColor}
          opacity={1}
        />
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          className="my-btn clickable"
          onClick={applyGradient}
          type="button"
        >
          Apply
        </button>
        <button
          className="my-btn clickable"
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default GradientPicker;